// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yq-checkbox[data-v-a119a724] {\n  display: inline-flex;\n  margin-right: 0.26667rem;\n}\n.yq-checkbox[data-v-a119a724]:last-child {\n  margin-right: 0;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
